import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

const BLOCK_TYPES = [
  {label: 'P', style: 'unstyled'},
];

const BasicBlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type, i) =>
        <StyleButton
          key={i}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          promptForLink={props.promptForLink}
          removeLink={props.removeLink}
        />
      )}
    </div>
  );
};

export default BasicBlockStyleControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/BasicBlockStyleControls.js.jsx